import axiosInstance from '../axiosInterceptor/axiosInstance'

const googleAuthorizationCallback = async (data) => {
  const { code, orgId } = data
  const url = `v1/orgs/${orgId}/youtube/account`
  return axiosInstance.put(url, { code })
}

export default googleAuthorizationCallback
